import { atom } from 'jotai'

/** 处于生成状态中的列表 */
export const pendingAtom = atom<
  { toastID: string; productID: number; postID: number }[]
>([])
